var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTwitter = function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.549 14.188a3.07 3.07 0 0 1-2.527-1.415q.48-.017.928-.14l-.032-.972a3.07 3.07 0 0 1-2.37-2.266c.323.094.661.15 1.01.16l1.748.057-1.454-.972a3.06 3.06 0 0 1-1.238-3.425A10.61 10.61 0 0 0 9.795 8.52l.663.033-.15-.646a3.065 3.065 0 0 1 5.224-2.796l.188.202.272-.054q.458-.09.894-.233-.252.242-.551.42l.316.926q.243-.028.48-.072-.269.242-.562.454l-.22.158.012.27q.01.218.01.44c0 4.496-3.42 9.644-9.645 9.644a9.6 9.6 0 0 1-3.452-.64 7.65 7.65 0 0 0 3.574-1.545l1.107-.868z"
  })));
};
export default SvgTwitter;